let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8Rls2")).then(() => parcelRequire('gVKtP'));